<template>
  <div id="app">
    <div id="nav">
      <router-link to="/"></router-link>
    </div>
    <router-view />
    <activityModal
      v-if="$store.state.activityModal && $store.state.activityModal.visible"
    ></activityModal>
  </div>
</template>

<script>
import { getCookie, getQuery, isShowActivityModal } from '@/util/util'
import activityModal from '@/components/activityModal'
import { sensorVisitorSet } from '@/util/sensors'
import { COOKIE_TIME_STR } from '@ost/static'

export default {
  components: {
    activityModal
  },
  created () {
    this.initChannelNo()
    this.$store
      .dispatch('getSysPosterConfigList', {
        module: 2,
        status: 1,
        showPosition: '41'
      })
      .then(res => {
        if (res.data.length) {
          this.$store.state.activityModal.visible =
            ['index'].includes(this.$route.name) &&
            isShowActivityModal('activityModalTime')
          let objData = res.data[0] || {}
          this.$store.state.activityModal.posterId = objData.posterId
          this.$store.state.activityModal.imageUrl = objData.posterImg
          this.$store.state.activityModal.linkUrl =
            objData.showType != 2 ? objData.showWay : ''
        } else {
          this.$store.state.activityModal.visible = false
          this.$store.state.activityModal.posterId = ''
          this.$store.state.activityModal.imageUrl = ''
          this.$store.state.activityModal.linkUrl = ''
        }
      })
  },
  watch: {
    $route () {
      this.$store.state.activityModal.visible =
        ['index'].includes(this.$route.name) &&
        !!this.$store.state.activityModal.imageUrl &&
        isShowActivityModal('activityModalTime')
    }
  },
  methods: {
    initChannelNo () {
      const query = getQuery()
      let channel = query.channelNo || query.channelCode
      console.log('渠道码：', channel)

      const channelCode =
        channel || getCookie('channelNo') || getCookie('channelCode')
      channelCode && sensorVisitorSet({ channelCode })

      if (channel) {
        let domain = '.ippmaster.com'

        if (window.location.href.indexOf('ippmaster.com') !== -1) {
          domain = '.ippmaster.com'
        } else if (window.location.href.indexOf('ost.com') !== -1) {
          domain = '.ost.com'
        } else {
          // domain = 'localhost'
          domain = '192.168.10.81'
        }

        // cookie中的channelCode是最新的渠道码
        document.cookie = `channelCode=${channel};path=/;domain=${domain}${COOKIE_TIME_STR}`
        if (!getCookie('channelNo')) {
          // cookie中的channelNo是第一次的渠道码
          document.cookie = `channelNo=${channel};path=/;domain=${domain}${COOKIE_TIME_STR}`
        }
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 768px;
  margin: auto;
}
</style>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/App.vue